import { useQuery } from '@apollo/client/react';
import { useError } from 'contexts/error';
import ProfileQuery from 'queries/user/header';

const useUserHeader = () => {
  const setError = useError();
  const {
    data = { user: { email: '...' }, space: { id: null, name: '', adminRole: false } },
    loading,
  } = useQuery(ProfileQuery, {
    fetchPolicy: 'cache-first',
    onError: () => {
      setError('error.user.profile.show');
    },
  });

  return {
    user: data.user,
    space: data.space,
    loading,
  };
};

export default useUserHeader;
